import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Contribution } from '@services/member/contribution/contribution.types';

export const useContributionEditionPageVM = () => {

    const [totalContributions, setTotalContributions] = useState<number>(0);
    const columnHelper = createColumnHelper<Contribution>();

    const navigate = useNavigate();


    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalContributions(metadata.total);
        }
    };

    return {
        handleMetadata,
        navigate,
        columnHelper,
        totalContributions
    };
};
